import React, { useEffect, useState } from 'react';
import { isClientEnv } from '@app/src/utils/validations';
import { useSelector } from 'react-redux';
import {
  WrapperStep,
  WrapperStepLeft,
  Overlay,
  WrapperStepRight,
  Container,
  Wrapper,
} from './styled';
import { CounterAvailableFeature } from '@app/src/common/CounterAvailable';
import { FlashMessageDiscount } from '@app/src/views/StepTwo/channelPublication';

const isClient = isClientEnv();

interface Props {
  children: React.ReactNode;
  alias: string;
  announcementAvailable?: boolean;
}

export const StepContainer: React.FC<Props> = ({ children, alias, announcementAvailable }) => {
  const isShow = useSelector(state => state.headBand.show);
  const [heightHeader, setHeightHeader] = useState(0);

  useEffect(() => {
    handleResize();
    if (isClient) {
      (window as any).addEventListener('resize', handleResize);
      return () => {
        (window as any).addEventListener('resize', handleResize);
      }
    }
  }, []);
  
  useEffect(() => {
    handleResize();
  }, [isShow]);

  const handleResize = () => {
    const header = isClient && document.getElementById('header');
    const current = header && header.offsetHeight || 0;
    const headBand = isClient && document.getElementById('headBand');
    const headBandHeight = headBand && headBand.offsetHeight || 0;
    setHeightHeader(current + headBandHeight);
  }

  return (
    <WrapperStep>
      <WrapperStepRight heightHeader={heightHeader}>
        <WrapperStepLeft
          alias={alias}
          heightHeader={heightHeader}
        >
          {announcementAvailable && <CounterAvailableFeature />}
          <Overlay alias={alias} />
        </WrapperStepLeft>
        <Container>
          <Wrapper>
            {children}
          </Wrapper>
        </Container>
        <FlashMessageDiscount />
      </WrapperStepRight>
    </WrapperStep>
  )
};
